/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker } from 'components/filters';
import {
  OrderFullfillmentCenterSelect,
  OrganizationInOmsServiceSelect,
} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function PurchaseOrderFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.orderNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.supplierOrderNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.purchaseOrderState === 'undefined' && (
          <FormGroup>
            <Label>Status</Label>
            <Select
              instanceId="select-purchaseOrderState"
              name="purchaseOrderState"
              value={_.get(resolvedQuery, 'purchaseOrderState', '')}
              onChange={handleChange}
              options={[
                { value: 'draft', label: 'Utkast' || 'draft' },
                {
                  value: 'waitingForFlaivyApproval',
                  label: 'Granskas' || 'waitingForFlaivyApproval',
                },
                {
                  value: 'sentToSupplier',
                  label: 'Beställd' || 'sentToSupplier',
                },
                { value: 'shipped', label: 'På väg' || 'shipped' },
                { value: 'received', label: 'Mottagen' || 'received' },
                {
                  value: 'partialyDelivered',
                  label: 'Delleverans' || 'partialyDelivered',
                },
                { value: 'delivered', label: 'Levererad' || 'delivered' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.supplierMessage === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.deliveryDate === 'undefined' && (
          <FormGroup>
            <Label>Beräknat leveransdatum</Label>
            <DateRangePicker
              name="deliveryDate"
              value={_.get(resolvedQuery, 'deliveryDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.receivedDate === 'undefined' && (
          <FormGroup>
            <Label>Datum då leveransen kom till lagret</Label>
            <DateRangePicker
              name="receivedDate"
              value={_.get(resolvedQuery, 'receivedDate')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.cancelled === 'undefined' && (
          <FormGroup>
            <Label>Makulerad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'cancelled') === undefined}
                onClick={() => {
                  handleChange('cancelled', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === true ||
                  _.get(resolvedQuery, 'cancelled') === 'true'
                }
                onClick={() => {
                  handleChange('cancelled', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'cancelled') === false ||
                  _.get(resolvedQuery, 'cancelled') === 'false'
                }
                onClick={() => {
                  handleChange('cancelled', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.owningSupplierOrganization === 'undefined' && (
          <FormGroup>
            <Label>Leverantörorganisation</Label>
            <OrganizationInOmsServiceSelect
              defaultOptions={false}
              instanceId="select-owningSupplierOrganization"
              name="owningSupplierOrganization"
              value={_.get(resolvedQuery, 'owningSupplierOrganization')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.trackingCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.ARCNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.requiresEMCS === 'undefined' && (
          <FormGroup>
            <Label>Behöver EMCS?</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'requiresEMCS') === undefined}
                onClick={() => {
                  handleChange('requiresEMCS', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresEMCS') === true ||
                  _.get(resolvedQuery, 'requiresEMCS') === 'true'
                }
                onClick={() => {
                  handleChange('requiresEMCS', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'requiresEMCS') === false ||
                  _.get(resolvedQuery, 'requiresEMCS') === 'false'
                }
                onClick={() => {
                  handleChange('requiresEMCS', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isEMCSProcessed === 'undefined' && (
          <FormGroup>
            <Label>Är EMCS-processad?</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isEMCSProcessed') === undefined}
                onClick={() => {
                  handleChange('isEMCSProcessed', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isEMCSProcessed') === true ||
                  _.get(resolvedQuery, 'isEMCSProcessed') === 'true'
                }
                onClick={() => {
                  handleChange('isEMCSProcessed', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isEMCSProcessed') === false ||
                  _.get(resolvedQuery, 'isEMCSProcessed') === 'false'
                }
                onClick={() => {
                  handleChange('isEMCSProcessed', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.targetWarehouse === 'undefined' && (
          <FormGroup>
            <Label>Till lager</Label>
            <Select
              type="string"
              instanceId="select-targetWarehouse"
              name="targetWarehouse"
              value={_.get(resolvedQuery, 'targetWarehouse')}
              onChange={handleChange}
              options={[
                { label: 'Kungsängen', value: 'vinden' },
                { label: 'Karlskoga', value: 'exacta' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.remarks === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.orderFullfillmentCenter === 'undefined' && (
          <FormGroup>
            <Label>Lagerställe</Label>
            <OrderFullfillmentCenterSelect
              defaultOptions={false}
              instanceId="select-orderFullfillmentCenter"
              name="orderFullfillmentCenter"
              value={_.get(resolvedQuery, 'orderFullfillmentCenter')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.owningSupplierOrganizationId === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.hasInactiveArticle === 'undefined' && (
          <FormGroup>
            <Label>Finns utgångna artiklar på lager</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasInactiveArticle') === undefined
                }
                onClick={() => {
                  handleChange('hasInactiveArticle', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasInactiveArticle') === true ||
                  _.get(resolvedQuery, 'hasInactiveArticle') === 'true'
                }
                onClick={() => {
                  handleChange('hasInactiveArticle', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'hasInactiveArticle') === false ||
                  _.get(resolvedQuery, 'hasInactiveArticle') === 'false'
                }
                onClick={() => {
                  handleChange('hasInactiveArticle', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.handledByFlaivy === 'undefined' && (
          <FormGroup>
            <Label>Behöver specialhantering av flaivy</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'handledByFlaivy') === undefined}
                onClick={() => {
                  handleChange('handledByFlaivy', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'handledByFlaivy') === true ||
                  _.get(resolvedQuery, 'handledByFlaivy') === 'true'
                }
                onClick={() => {
                  handleChange('handledByFlaivy', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'handledByFlaivy') === false ||
                  _.get(resolvedQuery, 'handledByFlaivy') === 'false'
                }
                onClick={() => {
                  handleChange('handledByFlaivy', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.purchaseOrderRows === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.purchaseOrderDeliveries === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

PurchaseOrderFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

PurchaseOrderFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function PurchaseOrderFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <PurchaseOrderFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

PurchaseOrderFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

PurchaseOrderFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { PurchaseOrderFilterPanel, PurchaseOrderFilterPanelModal };
